import React from 'react';
import ThinkingMascot from '../../assets/thinking-mascot.png';
import { ReactComponent as ValidityCheckMeta } from '../../assets/validity-check-meta.svg';
import { ReactComponent as ValidityCheckPhone } from '../../assets/validity-check-phone.svg';
import ValidationStep from './ValidationStep';
import { DESCRIPTIONS, PHONE_VALIDATION_OPTIONS } from './constants';

const EligibilityCheck = ({
  eligibilityStatus,
  eligibilityStep,
  setEligibilityStep,
  phoneValidationOption,
  subStep,
  onPhoneValidationChange,
}) => {
  const renderPhoneValidationDescription = () => {
    if (eligibilityStep === 1) {
      if (subStep === '') {
        return 'Do you have a valid phone number capable of sending and receiving SMS? A phone number is required to set up the WhatsApp Business Platform (API).';
      }
      if (subStep === 'existing') {
        return "If you want to use a phone number that's already linked to a WhatsApp Business or WhatsApp Personal account, you must first migrate and delete the existing account. Only then can you use the number to sign up for a WhatsApp Business Platform (API) account. Be sure to back up your chat history if you wish to retain your conversations.";
      }
      if (subStep === 'none') {
        return "To connect to the WhatsApp Business Platform (API), you'll need to purchase a new number. It's recommended to use a number that is not already linked to any existing WhatsApp account.";
      }
    } else {
      return (
        <span>
          Are you able to access the Meta Business Manager (MBM) account linked to your company?{' '}
          <br /> If you don't have an MBM account, you can create one during the connection process
          instead.
        </span>
      );
    }
  };

  const renderInfoBanner = () => {
    return (
      <div className="info-banner">
        <i className="info-icon">i</i>
        <div className="info-content">
          <h3>
            Helpful to know! To create a WhatsApp Business Account (WABA), you'll need the following
            information:
          </h3>
          <ul>
            <li>The name of your company (as visible to customers)</li>
            <li>The legal company name</li>
            <li>The company's official address</li>
          </ul>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="mascot">
        <img src={ThinkingMascot} alt="Thinking Mascot" />
      </div>
      <div className="eligibility-check-wrapper">
        <h2>{DESCRIPTIONS.ELIGIBILITY_CHECK}</h2>

        <div className="validation-steps-container">
          <ValidationStep
            icon={<ValidityCheckPhone />}
            text="Valid Phone Number"
            status={eligibilityStatus.step1}
            isFirst={true}
          />
          <ValidationStep
            icon={<ValidityCheckMeta />}
            text="Meta Business Manager Access"
            status={eligibilityStatus.step2}
            isFirst={false}
          />
        </div>

        <p className="validation-description">{renderPhoneValidationDescription()}</p>

        {eligibilityStep === 1 && subStep === '' && (
          <>
            <div className="radio-options">
              <label className="radio-label">
                <input
                  type="radio"
                  name="phone-validation"
                  value={PHONE_VALIDATION_OPTIONS.NEW}
                  checked={phoneValidationOption === PHONE_VALIDATION_OPTIONS.NEW}
                  onChange={onPhoneValidationChange}
                />
                <span className="custom-radio"></span>I have a new phone number that isn't linked to
                any WhatsApp account.
              </label>

              <label className="radio-label">
                <input
                  type="radio"
                  name="phone-validation"
                  value={PHONE_VALIDATION_OPTIONS.EXISTING}
                  checked={phoneValidationOption === PHONE_VALIDATION_OPTIONS.EXISTING}
                  onChange={onPhoneValidationChange}
                />
                <span className="custom-radio"></span>I have a phone number linked to a WhatsApp
                Business App or a personal WhatsApp account.
              </label>

              <label className="radio-label">
                <input
                  type="radio"
                  name="phone-validation"
                  value={PHONE_VALIDATION_OPTIONS.NONE}
                  checked={phoneValidationOption === PHONE_VALIDATION_OPTIONS.NONE}
                  onChange={onPhoneValidationChange}
                />
                <span className="custom-radio"></span>I don't have a new number.
              </label>
            </div>
          </>
        )}
        {eligibilityStep === 2 && renderInfoBanner()}
      </div>
    </>
  );
};

export default EligibilityCheck;
